import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop, InjectReactive } from "vue-property-decorator";
import basicsSetting from "./configSetting/basicsSetting.vue";
import empty from "./configSetting/empty.vue";
import singleChoice from "./configSetting/singleChoice.vue";
import singleChoicePicker from "./configSetting/singleChoicePicker.vue";
import fillIn from "./configSetting/fillIn.vue";
import fillInMulti from "./configSetting/fillInMulti.vue";
import fillInRange from "./configSetting/fillInRange.vue";
import fillInTable from "./configSetting/fillInTable.vue";
import dateTime from "./configSetting/dateTime.vue";
import addressInput from "./configSetting/addressInput.vue";
import multipleChoice from "./configSetting/multipleChoice.vue";
import sort from "./configSetting/sort.vue";
import proportion from "./configSetting/proportion.vue";
import multipleChoicePicker from "./configSetting/multipleChoicePicker.vue";
import cascade from "./configSetting/cascade.vue";
import imageSetting from "./configSetting/imageSetting.vue";
import textSetting from "./configSetting/textSetting.vue";
import submitBtnSetting from "./configSetting/submitBtnSetting.vue";
import uploadAddon from "./configSetting/uploadAddon.vue";
import phoneNumber from "./configSetting/phoneNumber.vue";
import logicSet from "./configSetting/logicSet.vue";
import cutOffLine from "./configSetting/cutOffLine.vue";
import pageGap from "./configSetting/pageGap.vue";
import calculator from "./configSetting/calculator.vue";
import patientName from "./configSetting/patientName.vue";
import age from "./configSetting/age.vue";
import sex from "./configSetting/sex.vue";
import diagnosisTime from "./configSetting/diagnosisTime.vue";
import diagnosis from "./configSetting/diagnosis.vue";
import onlineBooking from "./configSetting/onlineBooking.vue";
import department from "./configSetting/department.vue";
import submitSetting from "./configSetting/submitSetting.vue";
import { DecorationType, QuestionType } from "@/modules/newCommunity/pages/operationTools/config/newQuestionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import auditSetting from "./configSetting/auditSetting.vue";
let ModulesConfig = class ModulesConfig extends Vue {
  constructor() {
    super(...arguments);
    this.editSortDialogKey = Math.random();
    this.configSetStep = "item";
    this.realConfigSetStep = "item";
    this.addLogicSetDialogShow = false;
    this.loading = false;
    this.componentsActiveIndex = 0;
  }
  get isModel() {
    return QuestionnaireEditModule.isModel;
  }
  get editSpecialMode() {
    return QuestionnaireEditModule.editSpecialMode;
  }
  get action() {
    return QuestionnaireEditModule.action;
  }
  get activeIndex() {
    return QuestionnaireEditModule.activeIndex;
  }
  get isConfigForAll() {
    let configForAllBoolean = this.configSetStep == "all" || this.configSetStep == "audit" || this.dataList.length > 0 && this.dataList[this.componentsActiveIndex] && this.dataList[this.componentsActiveIndex].componentName == DecorationType.calculator;
    return configForAllBoolean;
  }
  get questionData() {
    return QuestionnaireEditModule.questionData;
  }
  get dataList() {
    return QuestionnaireEditModule.dataList;
  }
  get basicDataUniqueId() {
    return QuestionnaireEditModule.basicDataUniqueId;
  }
  get formLogicConfig() {
    return QuestionnaireEditModule.formLogicConfig;
  }
  get verificationConfig() {
    return QuestionnaireEditModule.verificationConfig;
  }
  get showVerifactionConfig() {
    return QuestionnaireEditModule.showVerifactionConfig;
  }
  get basicData() {
    return QuestionnaireEditModule.basicData;
  }
  // get componentName() {
  //   if (this.action == QuestionnaireSettingAction.empty) {
  //     return "empty";
  //   }
  //   // if (this.action == QuestionnaireSettingAction.submitBtn) {
  //   //   return "submitBtnSetting";
  //   // }
  //   if (this.dataList.length == 0) {
  //     return "empty";
  //   }
  //   const activeData = this.dataList[this.activeIndex];
  //   if (!activeData) {
  //     return "empty";
  //   }
  //   switch (activeData.componentName + "") {
  //     case QuestionType.singleChoice:
  //       return "singleChoice";
  //     case QuestionType.multipleChoice:
  //       return "multiChoice";
  //     case QuestionType.phoneNumber:
  //       return "phoneNumber";
  //     case QuestionType.fillIn:
  //       return "fillIn";
  //     case QuestionType.cascade:
  //       return "cascade";
  //     case QuestionType.uploadAddon:
  //       return "uploadAddon";
  //     case DecorationType.picture:
  //       return "imageSetting";
  //     case DecorationType.text:
  //       return "textSetting";
  //   }
  //   return "";
  // }
  async watchisConfigForAllData(value) {
    QuestionnaireEditModule.SET_configforAllSetting(!!value);
  }
  watchActiveIndexData(value) {
    // console.log("watchActiveIndexData in", value);
    this.$nextTick(async () => {
      // if (this.dataList.length > 0 && this.dataList[value] && this.dataList[value].componentName == DecorationType.calculator) {
      //   // 特殊组件 设计全局设置 需要先保存配置设置id;
      //   let result = await this.validate(true);
      //   // console.log("watchActiveIndexData ", result, value);
      //   if (result.valid) {
      //     //其他项验证通过
      //     let saveres = await QuestionnaireEditModule.SAVE_TEMPLATE(this.basicDataUniqueId || "");
      //     // console.log("saveres", saveres);
      //     if (saveres.data && saveres.code == "200") {
      //       QuestionnaireEditModule.SET_BASICDATA_ID(saveres.data);
      //       await QuestionnaireEditModule.GET_TEMPLATE(saveres.data);
      //       this.componentsActiveIndex = value;
      //     } else {
      //       QuestionnaireEditModule.SET_INDEX_COMPONENTS(0);
      //       this.componentsActiveIndex = 0;
      //     }
      //   }
      // }
      this.componentsActiveIndex = value;
    });
  }
  getComponentName(data) {
    switch (data.componentName) {
      case QuestionType.singleChoice:
        return "singleChoice";
      case QuestionType.singleChoicePicker:
        return "singleChoicePicker";
      case QuestionType.multipleChoice:
        return "multipleChoice";
      case QuestionType.sort:
        return "sort";
      case QuestionType.proportion:
        return "proportion";
      case QuestionType.multipleChoicePicker:
        return "multipleChoicePicker";
      case QuestionType.phoneNumber:
        return "phoneNumber";
      case QuestionType.fillIn:
        return "fillIn";
      case QuestionType.fillInMulti:
        return "fillInMulti";
      case QuestionType.fillInRange:
        return "fillInRange";
      case QuestionType.dateTime:
        return "dateTime";
      case QuestionType.addressInput:
        return "addressInput";
      case QuestionType.cascade:
        return "cascade";
      case QuestionType.uploadAddon:
        return "uploadAddon";
      case QuestionType.fillInTable:
        return "fillInTable";
      case DecorationType.picture:
        return "imageSetting";
      case DecorationType.text:
        return "textSetting";
      case DecorationType.pageGap:
        return "pageGap";
      case DecorationType.cutOffLine:
        return "cutOffLine";
      case DecorationType.calculator:
        return "calculator";
      case QuestionType.patientName:
        return "patientName";
      case QuestionType.age:
        return "age";
      case QuestionType.sex:
        return "sex";
      case QuestionType.diagnosisTime:
        return "diagnosisTime";
      case QuestionType.diagnosis:
        return "diagnosis";
      case QuestionType.onlineBooking:
        return "onlineBooking";
      case QuestionType.department:
        return "department";
      default:
        return "empty";
    }
  }
  async configSetStepChange(value, oldValue) {
    if (oldValue == "audit") {
      // 从审核规则切换走
      const vali = await this.auditSettingValidate();
      console.log("configSetStep", oldValue, vali);
      if (vali) {
        this.realConfigSetStep = value;
        this.$emit("configModeChange", value);
      } else {
        this.$message.error("请检查填写");
        this.configSetStep = "audit";
      }
    } else {
      if (value == "audit" && this.realConfigSetStep != "audit") {
        this.auditSettingInit();
      }
      this.realConfigSetStep = value;
      this.$emit("configModeChange", value);
    }
  }
  mounted() {
    this.$nextTick(() => {
      this.auditSettingInit();
    });
  }
  auditSettingInit() {
    console.log("auditSettingInit");
    this.$refs.auditSetting.init();
  }
  async auditSettingValidate() {
    return await this.$refs.auditSetting.validate();
  }
  async validatLogicSetData() {
    let result = false;
    // console.log("validatLogicSetData");
    if (this.formLogicConfig.itemShowLogics.length == 0) {
      return true;
    } else {
      result = await this.$refs.logicSet.validateForSave();
      return result;
    }
    // result = await (this.$refs.logicSet as any).validateForSave();
    // return result;
  }
  async validatAuditLogicSetData() {
    let result = false;
    // 因为auditSetting模块现在没有保存按钮 所以可能出现 点击提交按钮但是页面配置改写 没有同步到vuex;所以先保存在验证
    await this.$refs.auditSetting.updateData();
    //
    if (this.verificationConfig.itemVerificationList.length == 0) {
      return true;
    } else {
      result = await this.$refs.auditSetting.validateForSave();
      return result;
    }
    // result = await (this.$refs.logicSet as any).validateForSave();
    // return result;
  }
  async validate(skipOthers) {
    let result = {
      valid: true,
      index: 0
    };
    if (result.valid) {
      if (this.dataList.length === 0) {
        this.$message.warning("题目不能为空！");
        result = {
          valid: false,
          index: 0
        };
      }
    }
    if (result.valid) {
      // walkArray(this.dataList, (item, index) => {
      // if (item.componentName == QuestionType.singleChoice || item.componentName == QuestionType.multipleChoice) {
      //   const validateResult = choice.validate(item.data as ISingleChoiceData);
      //   if (!validateResult) {
      //     result = { valid: false, action: QuestionnaireSettingAction.question, index };
      //     return true;
      //   }
      // }
      // if (item.componentName == QuestionType.multipleChoice) {
      //   const validateResult = choice.validate(item.data as IMultipleChoiceData);
      //   if (!validateResult) {
      // result = { valid: false, action: QuestionnaireSettingAction.question, index };
      //     return true;
      //   }
      // }
      // if (item.componentName == QuestionType.fillIn) {
      //   const validateResult = fillInValidate.validate(item.data as IFillInData);
      //   if (!validateResult) {
      //     result = { valid: false, action: QuestionnaireSettingAction.question, index };
      //     return true;
      //   }
      // }
      // if (item.componentName == QuestionType.phoneNumber) {
      //   const validateResult = phoneNumValidate.validate(item.data as IPhoneNumberData);
      //   if (!validateResult) {
      //     result = { valid: false, action: QuestionnaireSettingAction.question, index };
      //     return true;
      //   }
      // }
      // if (item.componentName == QuestionType.uploadAddon) {
      //   const validateResult = uploadAddonValidate.validate(item.data as IAddonData);
      //   if (!validateResult) {
      //     result = { valid: false, action: QuestionnaireSettingAction.question, index };
      //     return true;
      //   }
      // }
      // });
      for (let index in this.dataList) {
        let item = this.dataList[index];
        // console.log("his.dataList", index, this.getComponentName(item) + index);
        let validateResult = false;
        if (skipOthers && item.componentName == DecorationType.calculator) {
          // 需要跳过其他组件的验证;比如 计算组件;
          validateResult = true;
        } else {
          validateResult = await this.$refs[this.getComponentName(item) + index][0].validate();
        }
        // console.log("getvalidateResult", validateResult);
        if (!validateResult) {
          this.$message.warning("请检查填写");
          result = {
            valid: false,
            index: Number(index)
          };
          break;
        }
      }
      if (!result.valid) {
        QuestionnaireEditModule.SET_INDEX_COMPONENTS(result.index);
      } else {
        if (this.activityQuestionnaireProperty == "LIVE_PUBLIC_WELFARE" || this.activityQuestionnaireProperty == "LIVE_MEDICAL_CLASSROOM") {
          let appointmentComps = this.dataList.filter(item => {
            return item.componentName == QuestionType.onlineBooking;
          });
          if (appointmentComps.length == 0) {
            this.$message.warning("请设置预约组件");
            result = {
              valid: false,
              index: 0
            };
          }
          if (appointmentComps.length > 1) {
            this.$message.warning("该类型仅可设置一个预约组件");
            result = {
              valid: false,
              index: 0
            };
          }
        }
      }
    }
    // if (!result.valid) {
    //   this.$nextTick(() => {
    //     (this.$refs.settingPanel as any).validate();
    //   });
    // }
    return result;
  }
};
__decorate([Prop({
  default: "ACTIVITY_INTERACT"
})], ModulesConfig.prototype, "activityQuestionnaireProperty", void 0);
__decorate([InjectReactive()], ModulesConfig.prototype, "surveyType", void 0);
__decorate([Watch("isConfigForAll")], ModulesConfig.prototype, "watchisConfigForAllData", null);
__decorate([Watch("activeIndex")], ModulesConfig.prototype, "watchActiveIndexData", null);
__decorate([Watch("configSetStep")], ModulesConfig.prototype, "configSetStepChange", null);
ModulesConfig = __decorate([Component({
  name: "ModulesConfig",
  components: {
    empty,
    basicsSetting,
    singleChoice,
    singleChoicePicker,
    multipleChoice,
    sort,
    proportion,
    multipleChoicePicker,
    fillIn,
    fillInMulti,
    fillInRange,
    fillInTable,
    uploadAddon,
    cascade,
    phoneNumber,
    submitBtnSetting,
    imageSetting,
    textSetting,
    logicSet,
    dateTime,
    addressInput,
    cutOffLine,
    pageGap,
    calculator,
    patientName,
    age,
    sex,
    diagnosisTime,
    diagnosis,
    onlineBooking,
    auditSetting,
    department,
    submitSetting
  },
  filters: {}
})], ModulesConfig);
export default ModulesConfig;